export const BUSINESS_CASE_TIMELINE_EVENT_DIRECTIONS = ['inbound', 'outbound', 'internal'] as const;
